import { EMarkAsReadNotificationActionTypes, TMarkAsReadNotificationSucceed } from './types';
import { actionGenerator } from '../../../utils/redux/actionGenerator';

export const markAsReadSucceed: (id: number) => TMarkAsReadNotificationSucceed = actionGenerator<
  EMarkAsReadNotificationActionTypes.Succeed,
  number
>(EMarkAsReadNotificationActionTypes.Succeed);
